import React, { useContext, useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { AppRoutes } from "../../constants/appRoutes";
import { AuthContext } from "../../context/contextProvider";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Navigate } from "react-router-dom";
import OilBarrelIcon from "@mui/icons-material/OilBarrel";
import WorkOrderFormPage from "../workOrders/WorkOrderFormPage";
import useCurrentUserInfo from "../../hooks/useCurrentUserInfo";
import { useLocation } from "react-router-dom";

const breadcrumbs = [
  {
    IconComponent: DashboardIcon,
    title: "Dashboard",
    to: AppRoutes.dashboard,
  },
  {
    IconComponent: OilBarrelIcon,
    title: "DirectDrops",
    to: AppRoutes.deliveryOrders,
  },
  {
    IconComponent: AddIcon,
    title: "New",
  },
];

const DirectDropCreatePage = (props) => {
  const { state } = useLocation();
  const [workOrder, setWorkOrder] = useState();

  const { branchModules } = useContext(AuthContext);
  const userInfo = useCurrentUserInfo();

  useEffect(() => {
    setWorkOrder(state?.workOrder);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!branchModules?.directDrops || !userInfo.canCreateDeliveryOrders)
    return (
      <Navigate
        to={{
          pathname: AppRoutes.forbidden,
        }}
      />
    );

  return (
    <WorkOrderFormPage
      breadcrumbs={breadcrumbs}
      directDrop
      title="Direct Drops - New"
      workOrder={workOrder}
    />
  );
};

export default DirectDropCreatePage;
